export const STEP_DIRECTION_LEFT_TO_RIGHT = 'left-to-right';
export const STEP_DIRECTION_RIGHT_TO_LEFT = 'right-to-left';

export type STEP_TRANSITION_DIRECTION =
  | typeof STEP_DIRECTION_LEFT_TO_RIGHT
  | typeof STEP_DIRECTION_RIGHT_TO_LEFT;

export const STEP_TRANSITION_TIMEOUT = 300; // Default timeout for transitions in milliseconds
